const types = [
  'High Volume',
  'Standard',
  'Quality'
];

export default types;
